import React from "react";
import { Container, Row, Col } from "reactstrap";
import "./Awards.css";
import abcBlock from "../../assets/RealEnglishImages/abcBlock.svg"
const Awards = () => {
  return (
    <section className="award-section py-5">
      <Container>
        {/* Title Section */}
        <Row className="justify-content-center mb-5">
          <Col lg={8} className="text-center">
            <h2 className="display-4 fw-bold text-primary mb-3">
              ELT Excellence Awards <span className="text-warning">2024</span>
            </h2>
            <p className="lead">
              The ELT Excellence Awards honour excellence in English language teaching and learning offered by Private Primary and Secondary Schools, State Primary and Secondary Schools, as well as by Foreign Language Schools in Greece and Cyprus.
            </p>
          </Col>
        </Row>

        {/* Award Details Section */}
        <Row className="g-4">
          <Col lg={6} className="mb-4">
            <div className="award-card p-4 h-100">
              <h3 className="fw-bold text-success mb-3 d-flex align-items-center">
                Real English Academy Received an Award!
              </h3>
              <p className="mb-4">
                "This award celebrates schools that are safe, with pleasantly decorated classrooms, and unconventional classroom layouts that allow students to move freely, communicate, and collaborate with their peers, and enjoy learning in a happy atmosphere."
              </p>
              <div className="icon-text">
                <i className="mdi mdi-star-circle fs-36 text-warning me-3"></i>
                <span className="fw-bold">Outstanding Facilities</span>
              </div>
              <p className="mt-3">
                We are proud to provide an innovative, comfortable, and stimulating environment for all our students.
              </p>
            </div>
          </Col>

          {/* REAL's Unique Approach Section */}
          <Col lg={6} className="mb-4">
            <div className="award-card p-4 h-100">
              <h3 className="fw-bold text-primary mb-3">
                At REAL, We Foster a Home-Like Environment
              </h3>
              <ul className="list-unstyled">
                <li className="mb-3 d-flex align-items-center">
                  <i className="mdi mdi-slippers fs-24 text-info me-3"></i>
                  <div>
                    <strong>Wearing Slippers:</strong> Creating a cozy, home-like atmosphere.
                  </div>
                </li>
                <li className="mb-3 d-flex align-items-center">
 
                  <i className="mdi mdi-seat fs-24 text-success me-3"></i>
                  <div>
                    <strong>Flexible Seating:</strong> Enhancing engagement, collaboration, and independence.
                  </div>
                </li>
                <li className="mb-3 d-flex align-items-center">
                <img src={abcBlock} className="card-logo card-logo-dark pe-2" alt="logo dark" height="30"/>
                  <div>
                    <strong>Montessori-Inspired Baby Room:</strong> Nurturing early development, curiosity, and self-confidence.
                  </div>
                </li>
              </ul>

            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default Awards;